import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { RouteProps } from "./routes-path";
import { Grid, Typography } from "components/controls/widget";
import { MemberValidationState } from "../../../../member-validation/entity";
import { useMemberValidation, isMemberValidationState } from "../../../../member-validation/store";

const Error = () => {

    const [{ entity, errors }] = useMemberValidation()
    const { email, state } = entity;

    const showExpired = email && isMemberValidationState(state, MemberValidationState.EmailExpired);

    return <Grid container direction="column" spacing={8}>
        <Grid item>
            {showExpired && <Typography color="error" variant="subtitle1">{`Lhůta pro ověření emailu ${email} již expirovala. Pokud chcete email znovu ověřit, proveďte znovu žádost o ověření.`}</Typography>}
            {!showExpired && <Typography color="error" variant="subtitle1">{errors[''].errors}</Typography>}
        </Grid>

    </Grid>
}

const Success = () => {
    const { email } = useMemberValidation()[0].entity;

    return <Grid container direction="column" spacing={8}>
        <Grid item>
            <Typography color="primary" variant="subtitle1">{`Ověření emailové adresy ${email} proběhlo v pořádku.`}</Typography>
        </Grid>

    </Grid>
}

const Verification = () => {
    return <Grid container direction="column" spacing={8}>
        <Grid item>
            <Typography color="primary" variant="subtitle1">{'Probíhá ověření...'}</Typography>
        </Grid>

    </Grid>
}

interface Props extends RouteComponentProps<RouteProps> { }

const View = (props: Props) => {

    const { hashCode } = props.match.params;
    const [state, { validateEmail }] = useMemberValidation();

    React.useEffect(() => {
        validateEmail(hashCode);
    }, []);

    const showVerification = state.loading;
    const showSuccess = !state.loading && !state.loadFailure;
    const showError = state.loadFailure;

    return <Grid container direction="column" spacing={8}>
        <Grid item>
            <Typography variant="h5">{'Ověření emailové adresy člena'}</Typography>
        </Grid>
        <Grid item>
            {showVerification && <Verification />}
            {showSuccess && <Success />}
            {showError && <Error />}
        </Grid>
    </Grid>
}

const RoutedView = withRouter(View);

export {
    RoutedView as OvereniEmailu,
}